import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const defaultPosOrderServiceCost = "";
export const posOrderServiceCostAtom = atomWithStorage<string>(
  "posOrderServiceCostAtom",
  defaultPosOrderServiceCost
);

export const usePosOrderServiceCost = () => {
  const atom = useAtom(posOrderServiceCostAtom);
  return atom;
};

export const useSetPosOrderServiceCost = () =>
  useSetAtom(posOrderServiceCostAtom);

export default usePosOrderServiceCost;
